export type PlatformProviderChargeType = {
  id?: number;
  policy_platform: number | null;
  policy_provider: number | null;
  policy_type: number[];
  family_linked: boolean | null;
  charge_type: number | null;
  stepped_charge?: (number | null)[][];
  tiered_charge?: (number | null)[][];
  fixed_charge?: number | null;
  charge_value_type: number | null;
  aum_range: number[];
};

export const blankCharge = (
  policy_platform: number,
  policy_provider?: any
) => ({
  policy_platform,
  policy_provider,
  policy_type: [],
  family_linked: false,
  charge_type: 3,
  stepped_charge: [[0, null, null]],
  tiered_charge: [[0, null, null]],
  fixed_charge: null,
  charge_value_type: null,
  aum_range: []
});
export const blankPPCharge = () => ({
  policy_platform: null,
  policy_provider: null,
  policy_type: [],
  family_linked: false,
  charge_type: 3,
  stepped_charge: [[0, null, null]],
  tiered_charge: [[0, null, null]],
  fixed_charge: null,
  charge_value_type: null,
  aum_range: []
});
